import { privateRoutes } from './private.routes';
import { publicRoutes } from './public.routes';

export function createRoutes(auth, layouts) {
    if (!auth.isLogged) return publicRoutes(layouts);

    return privateRoutes(layouts);
}
